<template>
  <div>
    <h3 class="Contracts mt-30 mb-25">Importer Contract Refine (Indirect sales)</h3>
    <div class="bg-white py-40">
      <div class="row p-lg-0 p-20">
        <div class="col-lg-7 col-md-12 m-auto">
          <div class="form-group">
            <div class="form-row">
              <div class="col-lg-3 col-md-12">
                <label class="col-form-label">Importer Contract Refine</label>
              </div>
              <div class="col-lg-7 col-md-12">
                <div class="form-group">
                  <div class="drop drop-inline drop-sm">
                    <div class="cont">
                      <img alt=""
                           src="@/assets/img/icons/upload1.svg">
                      <div v-if="!importerContractRefineForm.file.tsync_id" class="desc"> Upload Excel File</div>
                      <div v-if="importerContractRefineForm.file.tsync_id" class="desc">
                        {{ importerContractRefineForm.file.name }}
                      </div>
                    </div>
                    <input ref="fileUploader" accept=".xls, .xlsx"
                           type="file"
                           @change="onExcelChange($event)" @click="resetFileUploader">
                    <div
                      v-if="$v.$error & !$v.importerContractRefineForm.file.tsync_id.required"
                      class="error">
                      An excel file is required.
                    </div>
                  </div>
                  <div class="d-inline-flex">
                    <i v-show="importerContractRefineForm.file.tsync_id" aria-hidden="true"
                       class="fa fa-times ml-2 clear-file"
                       @click="clearFile(importerContractRefineForm)"> Clear</i>
                  </div>
                </div>
              </div>
              <div class="col-lg-2 col-md-12">
                <div class="text-right">
                  <div class="d-inline-flex">
                    <button :disabled="!Object.keys(importerContractRefineContents).length || !isSaveButtonActive"
                            v-if="!isObserverUser" class="btn btn-submit" type="button"
                            @click="saveImporterContractRefine"> {{ saveButtonTxt }}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="form-group mb-30">
            <div class="row">
              <div class="col-12 col-md-12 col-lg-12 col-sm-12">
                <h4 v-show="fileLoading" class="text-warning">
                  <span v-show="!Object.keys(importerContractRefineContents).length">
                    Excel is loading. Please wait a moment
                  </span>
                </h4>
                <h6 v-show="uploadPercentage"
                    :class="uploadPercentage === 100 ? 'text-success':'text-warning'">
                    <span v-show="uploadPercentage!==100">
                     Please don't close this TAB before the upload is 100% completed.
                    </span>
                </h6>
                <div v-show="uploadPercentage && uploadPercentage!==100" class="progress">
                  <div :style="'width: '+uploadPercentage+'%'" aria-valuemax="100"
                       aria-valuemin="0" aria-valuenow="1" class="progress-bar progress-bar-striped bg-success"
                       role="progressbar">{{ uploadPercentage }}%
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row p-lg-0 p-20">
        <div class="col-md-12">
          <div class="p-3">
            <Table
              :api-prefix="apiPrefix"
              :committed-store="'setTraceabilityImporterContractRefineContent'"
              :dispatched-store="'getImporterContractRefineFromServer'"
              :is-data-fetched="loading"
              :table-data="tableData"
              :table-headers="tableHeaders"
              :table-search-config="tableSearchConfig"
              @updatedTableContents="getTableData"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import FormMixin from '@/mixins/form-mixin'
import { validationMixin } from 'vuelidate'
import UtilityMixin from '@/mixins/utility-mixin'
import { required } from 'vuelidate/lib/validators'
import xlsx from 'xlsx'
import Table from '@/components/admin/traceability/Table'
import { ContentTypes } from '@/config/constants'
import Menus from '@/config/menus'
import _ from 'lodash'

export default {
  name: 'ImporterContractRefine',
  components: { Table },
  data () {
    return {
      importerContractRefineForm: {
        file: {
          file: null,
          name: null,
          tsync_id: null
        }
      },
      importerContractRefineContents: {},
      importerContractRefines: {},
      tableHeaders: [
        {
          title: 'Contract',
          subtitle: 'No'
        },
        {
          title: 'Bill',
          subtitle: 'Of Lading'
        },
        {
          title: 'Container',
          subtitle: 'No'
        },
        {
          title: 'ICO',
          subtitle: 'Lot'
        },
        {
          title: 'Port of',
          subtitle: 'Origin'
        },
        {
          title: 'Port of',
          subtitle: 'Destination'
        },
        {
          title: 'Export',
          subtitle: 'Mill'
        }
      ],
      tableSearchConfig: [
        {
          header: 'Contract No',
          db_representation: 'contract__contract_no',
          widget_type: 'text'
        },
        {
          header: 'Bill Of Lading',
          db_representation: 'bill_of_lading_number',
          widget_type: 'text'
        },
        {
          header: 'Contract No',
          db_representation: 'container_no',
          widget_type: 'text'
        },
        {
          header: 'ICO Lot',
          db_representation: 'ico_lot',
          widget_type: 'text'
        },
        {
          header: 'Port Of Origin',
          db_representation: 'port_of_origin__name',
          widget_type: 'text'
        },
        {
          header: 'Port Of Destination',
          db_representation: 'port_of_destination__name',
          widget_type: 'text'
        },
        {
          header: 'Export Mill',
          db_representation: 'mill__name',
          widget_type: 'text'
        }
      ],
      searchDict: {
        searchField: '',
        searchText: '',
        date: '',
        fromDate: '',
        toDate: '',
        fromNumber: '',
        toNumber: ''
      },
      paginateDict: {
        nextUrl: null,
        previousUrl: null,
        currentPage: 1,
        totalPage: 1,
        firstPage: null,
        lastPage: null,
        remainingCount: 0,
        nextOffset: 0,
        totalCount: 0,
        dataPerPage: 5,
        previousPageNumber: 0,
        currentPageNumber: 0,
        nextPageNumber: 0
      },
      apiPrefix: 'v1/importer-contract-refine',
      tableData: [],
      loading: false,
      fileLoading: false,
      fileTsyncIdMapping: {},
      loadingText: 'Excel is loading. Please wait a moment',
      isSaveButtonActive: true,
      saveButtonTxt: 'Submit',
      uploadPercentage: 0
    }
  },
  computed: {
    importerContractRefinesContent () {
      return this.$store.getters.getTraceabilityAllCountryImporterContractRefineContents
    }
  },
  mixins: [FormMixin, validationMixin, UtilityMixin],
  validations: {
    importerContractRefineForm: {
      file: {
        tsync_id: { required }
      }
    }
  },
  methods: {
    resetFileUploader () {
      // It reset image or file uploader if same file selected again
      this.$refs.fileUploader.value = ''
    },
    onExcelChange (e) {
      this.importerContractRefineContents = {}
      if (e.target.files.length > 0) {
        const file = e.target.files[0]
        this.importerContractRefineForm.file.file = file
        this.importerContractRefineForm.file.name = file.name
        this.importerContractRefineForm.file.tsync_id = this.uuidV4()
        this.fileLoading = false
        this.prepareImporterContractRefineData()
        this.fileLoading = true
      } else {
        // if excel upload widget clicked and no file selected
        this.importerContractRefineForm.file.file = null
        this.importerContractRefineForm.file.name = null
        this.importerContractRefineForm.file.tsync_id = null
      }
    },
    prepareImporterContractRefineData () {
      if (this.importerContractRefineForm.file.file) {
        const file = this.importerContractRefineForm.file.file
        const fileReader = new FileReader()
        fileReader.onload = ev => {
          try {
            const data = ev.target.result
            const XLSX = xlsx
            const workbook = XLSX.read(data, {
              type: 'binary'
            })
            const wsname = workbook.SheetNames[0] // Take the first sheet，wb.SheetNames[0] :Take the name of the first sheet in the sheets
            const ws = XLSX.utils.sheet_to_json(workbook.Sheets[wsname])

            const excelData = [] // Clear received data
            //
            const wsLength = ws.length
            for (var i = 0; i < wsLength; i++) {
              excelData.push(ws[i])
            }
            this.importerContractRefineContents = excelData
          } catch (e) {
            return console.log('File can\'t read!')
          }
        }
        fileReader.readAsBinaryString(file)
      }
    },
    async saveImporterContractRefine () {
      this.$v.$touch()
      if (this.$v.$invalid) {
        this.$notify({
          title: '',
          text: 'Please fix error(s) in form.',
          type: 'error',
          duration: 5000
        })
      } else {
        this.isSaveButtonActive = false
        this.saveButtonTxt = 'Submitting...'
        const vm = this

        // start file upload log
        const fileUploadLogPromises = []
        const response = this.createFileUploadLog(this.importerContractRefineForm)
        fileUploadLogPromises.push(response)

        Promise.all(fileUploadLogPromises).then((values) => {
          const filePromises = []
          values.map((item) => {
            const fileId = item.data.file ? item.data.file.id : 0
            const fileTsyncId = item.data.file ? item.data.file.tsync_id : ''
            if (fileId === 0 || fileTsyncId === '') return
            const file = this.fileTsyncIdMapping[fileTsyncId]
            if (!file) return
            const response = this.uploadFile(fileId, file)
            filePromises.push(response)
          })
          Promise.all(filePromises).then((fileResponses) => {
            // this.$notify({
            //   title: '',
            //   text: 'File upload log created successfully.',
            //   type: 'success', // 'warn', 'error', 'success'
            //   duration: 5000
            // })
            this.$forceUpdate()
          })
        })
        // end file upload log

        let dataPosted = 0
        let dataNotPosted = 0
        const tempData = []

        const importerContractRefinePromises = []
        let importerContractRefineUploadCount = 0
        const totalImporterContractRefine = _.size(vm.importerContractRefineContents)
        const promises = await vm.importerContractRefineContents.reduce(async (memo, v) => {
          await memo
          const response = vm.submitEachImporterContractRefine(v)
          var myPromise = this.MakeQuerablePromise(response)
          response.then(function (data) {
            if (myPromise.isFulfilled()) {
              importerContractRefineUploadCount += 1
              vm.uploadPercentage = Math.ceil(importerContractRefineUploadCount / totalImporterContractRefine * 100)
            }
          })
          importerContractRefinePromises.push(response)
        }, [])
        _.unset(promises, '')

        Promise.all(importerContractRefinePromises).then((values) => {
          values.map((item) => {
            const data = item.data
            if (data.success) {
              if (!_.get(data, 'results')) {
                tempData.push(data)
              } else {
                this.$store.commit('setTraceabilityImporterContractRefineContent', data.results)
              }
              dataPosted += 1
            } else {
              this.$notify({
                title: 'ImporterContractRefine',
                text: data.message,
                type: 'error', // 'warn', 'error', 'success'
                duration: 10000
              })
              dataNotPosted += 1
              vm.errorLog(item)
            }
          })
          this.isSaveButtonActive = true
          this.saveButtonTxt = 'Submit'

          if (tempData.length > 0) {
            vm.$store.commit('setTraceabilityImporterContractRefineContent', tempData)
            this.getTableData(tempData)
          }
          if (dataNotPosted > 0) {
            this.$notify({
              title: 'ImporterContractRefine',
              text: `${dataNotPosted} Importer Contract Refine not created/ updated.`,
              type: 'error'
            })
          }
          if (dataPosted > 0) {
            this.$notify({
              title: 'ImporterContractRefine',
              text: `${dataPosted} Importer Contract Refine created/ updated successfully.`,
              type: 'success', // 'warn', 'error', 'success'
              duration: 5000
            })
          }
        })
      }
    },
    getTableData (payload) {
      if (payload) {
        payload = this.$store.getters.getTraceabilityAllCountryImporterContractRefineContents
      }
      this.tableData = []
      for (const _data of payload) {
        const tempData = []
        const contract = _.get(_data, 'contract') || null
        tempData.push(_.get(contract, 'contract_no') || 'N/A')
        tempData.push(_.get(_data, 'bill_of_lading_number') || 'N/A')
        tempData.push(_.get(_data, 'container_no') || 'N/A')
        tempData.push(_.get(_data, 'ico_lot') || 'N/A')
        tempData.push(_.get(_data, 'port_of_origin.name') || 'N/A')
        tempData.push(_.get(_data, 'port_of_destination.name') || 'N/A')
        tempData.push(_.get(_data, 'mill.name') || 'N/A')
        this.tableData.push(tempData)
      }
      return this.tableData
    },
    async submitEachImporterContractRefine (data) {
      const formData = this.$_.cloneDeep(data)
      return await this.$store.dispatch('createOrUpdateTraceabilityImporterContractRefineContent', formData)
    },
    async createFileUploadLog (data) {
      const formData = this.$_.cloneDeep(data)
      const fileTsyncId = (formData.file && formData.file.tsync_id) ? formData.file.tsync_id : this.uuidV4()
      this.fileTsyncIdMapping[fileTsyncId] = data.file.file
      if (this.importerContractRefineForm.file.file) {
        if (!formData.id) {
          formData.file = {
            tsync_id: fileTsyncId,
            extension: formData.file.name.split('.').pop()
          }
        } else {
          try {
            formData.file.extension = formData.file.name.split('.').pop()
          } catch (e) {
            this.errorLog(e)
          }
        }
      }
      formData.content_type = ContentTypes.FILE
      formData.content = this.$store.getters.getContentByAppModule(Menus.traceability.key).id
      return await this.$store.dispatch('createOrUpdateTraceabilityContents', formData)
    }
  },
  watch: {
    importerContractRefinesContent: {
      deep: true,
      handler (newValue) {
        this.importerContractRefines = _.cloneDeep(newValue)
      }
    }
  },
  created () {
    window.onbeforeunload = () => (this.uploadPercentage ? true : null)
  }
}
</script>

<style lang="scss" scoped>

.clear-file {
  cursor: pointer;
}

.drop-sm {
  padding-right: 60px !important;
  max-width: 100%; // if file name is long than it wont overflow next close button
}
</style>
